module.exports = __webpack_public_path__ + "img/Small-Vertical-Rectangular-Attachment-25.5703faf0.png";